import { useLocalStorage } from "@domun/component-library";

export const useDeliveryToken = () => {
  const [token] = useLocalStorage("accessToken", "");
  return token || "";
};
